import { render, staticRenderFns } from "./preformatted-modal-macro.vue?vue&type=template&id=303a9e20&scoped=true&"
import script from "./preformatted-modal-macro.ts?vue&type=script&lang=ts&"
export * from "./preformatted-modal-macro.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-modal-macro.scss?vue&type=style&index=0&id=303a9e20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303a9e20",
  null
  
)

export default component.exports